import React, { FC } from 'react';
import { SvgIcon } from '@mui/material';

import type { IconAssetProps } from '../../types/components/icon_types';

export const Standing: FC<IconAssetProps> = ({ size, sx }: IconAssetProps) => {
  const style = size ? { width: `${size}px` } : {};

  return (
    <SvgIcon sx={{ ...style, ...sx }}>
      <g id="person 1">
        <path
          id="Vector"
          d="M9.99875 5.2475C11.2731 5.2475 12.31 4.21062 12.31 2.93625C12.31 1.66188 11.2734 0.625 9.99875 0.625C8.72406 0.625 7.6875 1.66156 7.6875 2.93625C7.6875 4.21094 8.72406 5.2475 9.99875 5.2475ZM9.99875 1.25C10.9284 1.25 11.685 2.00656 11.685 2.93625C11.685 3.86594 10.9284 4.6225 9.99875 4.6225C9.06906 4.6225 8.3125 3.86594 8.3125 2.93625C8.3125 2.00656 9.06906 1.25 9.99875 1.25Z"
          fill="black"
          stroke="black"
          strokeWidth="0.25"
        />
        <path
          id="Vector_2"
          d="M11.9957 5.70593H8.00414C6.87008 5.70593 5.94727 6.62874 5.94727 7.76281V12.9097C5.94727 13.0825 6.08695 13.2222 6.25977 13.2222H7.79102L8.04633 19.0762C8.05352 19.2431 8.19133 19.375 8.35852 19.375H11.6363C11.8035 19.375 11.9413 19.2431 11.9485 19.0762L12.2035 13.2222H13.7398C13.9126 13.2222 14.0523 13.0825 14.0523 12.9097V7.76281C14.0523 6.62874 13.1298 5.70593 11.9957 5.70593ZM13.4276 12.5972H12.2173V8.62593C12.2173 8.45312 12.0776 8.31343 11.9048 8.31343C11.732 8.31343 11.5923 8.45312 11.5923 8.62593V12.9028L11.3376 18.75H10.312V13.255C10.312 13.0822 10.1723 12.9425 9.99945 12.9425C9.82664 12.9425 9.68695 13.0822 9.68695 13.255V18.75H8.65789L8.40289 12.9028V8.62593C8.40289 8.45312 8.2632 8.31343 8.09039 8.31343C7.91758 8.31343 7.77789 8.45312 7.77789 8.62593V12.5972H6.57258V7.76281C6.57258 6.97343 7.21508 6.33093 8.00445 6.33093H11.996C12.7854 6.33093 13.4279 6.97343 13.4279 7.76281L13.4276 12.5972Z"
          fill="black"
          stroke="black"
          strokeWidth="0.25"
        />
      </g>
    </SvgIcon>
  );
};
